export default function ResponsiveImage({ name, alt, className = '', sizes = '100vw', eager = false }) {
  const srcSet = (extension) =>
    [640, 1024, 1600]
      .map((width) => `/images/optimized/${name}-${width}.${extension} ${width}w`)
      .join(', ')

  return (
    <picture className={className}>
      <source type="image/webp" srcSet={srcSet('webp')} sizes={sizes} />
      <img
        src={`/images/optimized/${name}-1024.webp`}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        fetchPriority={eager ? 'high' : 'auto'}
        decoding="async"
      />
    </picture>
  )
}
